import React, { useEffect, useState } from 'react';
import { NavLink, useLocation, useParams } from "react-router-dom";
import axios from "axios";
import "./LivePage.css"
import { useNavigate } from "react-router";
import {
    Select,
    AutocompleteItem,
    Autocomplete, Chip,
    Pagination, SelectItem,
    Table,
    TableBody,
    TableCell,
    TableColumn,
    TableHeader,
    TableRow, Tooltip, Avatar, DropdownMenu, DropdownItem, Dropdown, ModalHeader, ModalContent, ModalBody, Modal,
    ModalFooter, Button
} from "@heroui/react";
import UserChip from "../components/UserChip";
import { CheckIcon } from "./ChatPage";
import HoverMedals from "../components/HoverMedals";
import Draggable from "react-draggable";
import OnlineChart from "../components/OnlineChart";
import {LiveMessageChart} from "../components/LineChart";
import PlayBackForm from "../components/PlayBackForm";

function PlayIcon() {
    return (
<svg xmlns="http://www.w3.org/2000/svg" class="icon" viewBox="0 0 24 24" width="24" height="24">
    <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z"/>
    <path d="M719.4 499.1l-296.1-215A15.9 15.9 0 0 0 398 297v430c0 13.1 14.8 20.5 25.3 12.9l296.1-215a15.9 15.9 0 0 0 0-25.8zm-257.6 134V390.9L628.5 512 461.8 633.1z"/>
               </svg>
    )
}


function LiveDetailPage(props) {
    let { id } = useParams();
    const { search } = useLocation();
    const params = new URLSearchParams(search);
    const host = location.hostname;
    const [actions, setActions] = useState([])

    const ref = React.createRef();

    const redirect = useNavigate();
    const [mid, setMid] = useState(0);

    const videoRef = React.createRef();
    const [playing, setPlaying] = useState(false);
    const [stream, setStream] = useState('');
    useEffect(() => {
        refreshData(currentPage, pageSize)
    }, [])
    const p = parseInt(params.get("page"))
    const [currentPage, setCurrentPage] = useState(isNaN(p) ? 1 : p)

    const [pageSize, setPageSize] = useState( parseInt(localStorage.getItem("defaultPageSize")));
    const [dataSource, setDatasource] = useState([])

    const highLight = params.get("highLight")


    const [total, setTotal] = useState(0)
    const [selected, isSelected] = useState(false)

    const [name, setName] = useState(null)
    const [order, setOrder] = useState("undefined")
    const [filters, setFilters] = useState([
        { text: 'Joe', value: 'Joe' },
        { text: 'Jim', value: 'Jim' },
        { text: 'Category 1', value: 'Category 1' },
        { text: 'Category 2', value: 'Category 2' },
    ]);

    const [showMinuteChart,setShowMinuteChart] = useState(false)
    const [columns, setColumn] = useState([])

    const [liveInfo, setLiveInfo] = useState({});

    const [hideStream, setHideStream] = useState(false);

    const [menu, setMenu] = useState(false)
    const [msgData,setMsgData] = useState([])

    const [user, setUser] = useState([]);
    useEffect(() => {
        refreshData(currentPage, pageSize)
    }, [order])

    const [filter, setFilter] = useState('')

    const [playBack,setPlayBack] = useState([])



    useEffect(() => {

        setColumn([
            {
                title: 'Name',
                dataIndex: 'FromName',
                key: 'UserName',
                filterSearch: true,
                filters: filters,
                render: (text, record) => (
                    <span style={{ cursor: 'pointer' }} onClick={() => {
                        window.open("https://space.bilibili.com/" + record.FromId)
                    }}>
                        {text}{console.log(record)}
                    </span>
                )
            },
            {
                title: 'Time',
                dataIndex: 'CreatedAt',
                key: 'StartAt',
            },
            {
                title: 'Message',
                dataIndex: 'Extra',
                key: 'Message'
            }
        ])
    }, [])
    const port = location.port

    const tableRef = React.createRef()
    const protocol = location.protocol.replace(":", "")
    const refreshData = (page0, size, name) => {

        var page = parseInt(page0)

        if (!window.LIVE_MSG_CACHE) {
            window.LIVE_MSG_CACHE = []
        }

        const handleResponse = (obj) => {
            obj.records.forEach((item, index) => {
                if (item.GiftName != "") {
                    obj.records[index].Extra = item.GiftName
                }
                //res.data.records[index].Liver = res.data.liver
                obj.records[index].GiftPrice = obj.records[index].GiftPrice.Float64
                obj.records[index].CreatedAt = new Date(obj.records[index].CreatedAt).toLocaleString()
            })
            setTotal(obj.totalPages * size)
            console.log(total)
            setDatasource(obj.records)
        }
        if (page === undefined) {
            return
        }
        var url = `${protocol}://${host}:${port}/api/live/` + id + "/?" + "page=" + page + "&limit=" + size + "&order=" + order + "&mid=" + mid
        if (name != null) {
            url = url + `&name=${name}`
        }
        if (filter != null) {
            url = url + `&type=${filter}`
        }
        axios.get(`${protocol}://${host}:${port}/api/live/` + id + "/?" + "page=" + (page+1 )+ "&limit=" + size + "&order=" + order + "&mid=" + mid).then(response => {
            window.LIVE_MSG_CACHE[page+1] = response.data
        })

        if (window.LIVE_MSG_CACHE[page]) {
            handleResponse(window.LIVE_MSG_CACHE[page])
        } else {
            axios.get(url).then(res => {
                handleResponse(res.data)
            })
        }



    }
    useEffect(() => {
        var url = `${protocol}://${host}:${port}/api/liveDetail/` + id + "/"
        axios.get(url).then(res => {
            setLiveInfo(res.data.live)
            document.title = 'Vtuber 数据台 - ' + res.data.live.UserName + '  -  ' + res.data.live.Title
        })
        axios.get(`${protocol}://${host}:${port}/api/liveUser?live=${id}`).then(res => {
            setUser(res.data.list)
        })


        window.LIVE_MSG_CACHE = []

        axios.get("/api/playback?id=" + id).then(res => {
            setPlayBack(res.data.files??[])
        })

    }, []);



    useEffect(() => {
        liveInfo && liveInfo.RoomId && axios.get("/api/stream?room=" + liveInfo.RoomId).then(res => {
            setStream(res.data['Stream'])
        })
    }, [liveInfo]);

    useEffect(() => {
        console.log(stream)
    }, [stream]);

    useEffect(() => {
        refreshData(currentPage, pageSize)
    }, [filter, mid, pageSize])


    const handlePageChange = (page, pageSize, sorter) => {
        refreshData(page, pageSize, name)
        setCurrentPage(page)
        setPageSize(pageSize)
        console.log(sorter)

    }

    function formatTimeDiff(startTimestamp, endTimestamp) {
        const diffMs = Math.abs(endTimestamp - startTimestamp); // 毫秒差
        const diffMinutes = Math.floor(diffMs / 1000 / 60);

        if (diffMinutes <= 60) {
            return `${diffMinutes} 分钟`;
        } else {
            const diffHours = (diffMinutes / 60).toFixed(1); // 保留 1 位小数
            return `${diffHours} 小时`;
        }
    }

    const [showOnline, setShowOnline] = useState(false)

    const [showPlayBack,setShowPlayBack] = useState(false)






    return (
        <div>
            {showOnline && <OnlineChart id={id} onClose={() => {
                setShowOnline(false)
            }} />}
            {showMinuteChart &&                          <LiveMessageChart data={msgData} onClose={() => {
            setShowMinuteChart(false)
        }} id={id}/>}
            <PlayBackForm items={playBack} id={id}/>
            <div className="flex  space-x-4 rounded-2xl bg-white p-4 shadow-md overflow-scroll ">
                <div className="flex-1 space-y-2">
                    <h2 className="text-xl font-bold">{liveInfo.Title}</h2>
                    <div className="grid  grid-cols-1 sm:grid-cols-3 gap-2 text-sm ">
                        <div
                            className=" bg-blue-100 p-2 rounded-xl transition-transform transform-duration-500  hover:shadow-lg cursor-pointer ">
                            <span className="text-blue-600"></span>
                            <NavLink className='' to={`/liver/${liveInfo.UserID}`}>
                                <div className={'flex flex-row items-center text-blue-600 '}>
                                    <img src={`${AVATAR_API}${liveInfo.UserID}`} className='w-12 h-12 ml-4 mr-4 ' style={{ borderRadius: '50%' }}></img>
                                    {liveInfo.UserName}
                                </div>
                            </NavLink>

                        </div>
                        <div
                            onClick={() => {
                                if (playBack) {
                                    setShowPlayBack(true)
                                    PLAY_BACK_OPEN()
                                }
                            }}
                            className={`rounded-xl bg-gray-100 p-2 transition-transform duration-200 hover:scale-105 hover:shadow-lg ${playBack && playBack.length ?'bg-green-100':'bg-red-100'}`}>录播<br />
                    {/*        <span
                                className="font-semibold">{liveInfo.RoomId}</span>*/}
                            {playBack && playBack.length ? <span className={'font-semibold'}>点击查看</span>:<span className={'font-semibold'}>无</span>}
                        </div>
                        <div
                            className="rounded-xl bg-gray-100 p-2 transition-transform duration-200 hover:scale-105 hover:shadow-lg ">分区<br /><span className="font-semibold">{liveInfo.Area}</span>
                        </div>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-3 gap-2 text-sm">
                        <div


                            className="rounded-xl bg-gray-50 p-2 transition-transform duration-200 hover:scale-105 hover:shadow-lg ">开始时间            <br /><span
                                className="font-semibold">{new Date(liveInfo.StartAt * 1000 - 8 * 3600 * 1000).toLocaleString()}</span>
                            <div className={''}>

                            </div>
                        </div>
                        <div
                            className="rounded-xl bg-gray-50 p-2 transition-transform duration-200 hover:scale-105 hover:shadow-lg ">结束时间<br />
                            <span className="font-semibold">{new Date(liveInfo.EndAt * 1000).toLocaleString()}</span>
                        </div>
                        <div
                            className="rounded-xl bg-gray-50 p-2 transition-transform duration-200 hover:scale-105 hover:shadow-lg ">时长<br />
                            <span
                                className="font-semibold">{formatTimeDiff(liveInfo.StartAt * 1000 - 8 * 3600 * 1000, liveInfo.EndAt * 1000)}</span>
                        </div>
                    </div>

                    <div className="grid grid-cols-1 sm:grid-cols-3  gap-2 text-sm">
                        <div className="rounded-xl bg-green-100 p-2 text-green-700 transition-transform duration-200 hover:scale-105 hover:shadow-lg" onClick={() => {
                            setShowOnline(true)
                        }}>观众数<br />{liveInfo.Watch}</div>
                        <div className="rounded-xl bg-purple-100 p-2 text-fuchsia-600 transition-transform duration-200 hover:scale-105 hover:shadow-lg" onClick={() => {
                            axios.get("/api/minute?id=" + id).then(res => {
                                setMsgData(res.data.data)
                                setShowMinuteChart(true)
                            })
                        }}>弹幕数<br />{liveInfo.Message}
                        </div>
                        <div className="rounded-xl bg-rose-100 p-2 text-rose-600 transition-transform duration-200 hover:scale-105 hover:shadow-lg">流水<br />{liveInfo.Money}</div>
                    </div>
                </div>
            </div>

            <div>
                <Select
                    isClearable
                    onClear={() => setOrder('')}
                    className="max-w-xs mt-4 mb-4 ml-4 sm:ml-0"
                    items={[{
                        key: 'ascend',
                        value: "Ascend"
                    },
                    {
                        key: 'descend',
                        value: "Descend"

                    },
                    {
                        key: 'Time',
                        value: "Time"
                    }
                    ]}
                    label="Sort by"
                    onSelectionChange={e => {
                        console.log(e)
                        setOrder(e.currentKey)
                    }}
                >
                    {(f) => <SelectItem key={f.key}>{f.value}</SelectItem>}
                </Select>
                <Select
                    isClearable
                    setFilter={() => setFilter('')}
                    className="max-w-xs mt-4 mb-4 ml-4"
                    items={[{
                        key: 'msg',
                        value: "Message"
                    },
                    {
                        key: 'gift',
                        value: "Gift"

                    },
                    {
                        key: 'guard',
                        value: "Membership"
                    },
                    {
                        key: 'sc',
                        value: "SuperChat"
                    }
                    ]}
                    label="Filter by"
                    onSelectionChange={e => {
                        console.log(e)
                        setFilter(e.currentKey)
                    }}
                >
                    {(f) => <SelectItem key={f.key}>{f.value}</SelectItem>}
                </Select>
                <Select className="max-w-xs mt-4 mb-4 ml-4" label={'Page Size'} defaultSelectedKeys={[localStorage.getItem("defaultPageSize")]}>
                    <SelectItem onClick={e => { setPageSize(10); setCurrentPage(1) }} key={'10'}>
                        10
                    </SelectItem>
                    <SelectItem onClick={e => { setPageSize(50); setCurrentPage(1) }} key={'50'}>
                        50
                    </SelectItem>
                    <SelectItem onClick={e => { setPageSize(200); setCurrentPage(1) }} key={'200'}>
                        200
                    </SelectItem>
                    <SelectItem onClick={e => { setPageSize(500); setCurrentPage(1) }} key={'500'}>
                        500
                    </SelectItem>
                </Select>
                <Autocomplete
                    isClearable
                    setUser={() => setOrder('')}
                    className="max-w-xs mt-4 mb-4 ml-4"
                    items={user}
                    label="Search Watcher"
                    onSelectionChange={e => {
                        setMid(e)
                    }}
                    onInputChange={e => {
                        var url = `${protocol}://${host}:${port}/api/liveUser?live=${id}&keyword=${e}`;
                        axios.get(url).then((response) => {
                            setUser(response.data.list)
                        })
                    }}
                >
                    {(f) => <AutocompleteItem key={f.FromId} textValue={f.FromName}>
                        <UserChip props={f}></UserChip>
                    </AutocompleteItem>}
                </Autocomplete>

            </div>
            <Table bottomContent={
                <div className="flex w-full justify-center">
                    <Pagination
                        isCompact
                        showControls
                        showShadow
                        color="secondary"
                        page={currentPage}
                        total={total / pageSize}
                        onChange={(page) => {
                            handlePageChange(page, pageSize)
                            window.scrollTo({
                                top: 0,
                                behavior: "smooth"
                            })
                        }}
                    />
                </div>
            }
                   isStriped
                   className={(showMinuteChart || showOnline || showPlayBack)?'':'min-w-[800px] '}
            >

                <TableHeader>
                    {columns.map((col, index) => (
                        <TableColumn key={index} >{col.title}</TableColumn>

                    ))}
                </TableHeader>
                <TableBody>

                    {dataSource.map((item, index) => (
                        <TableRow key={index} onClick={() => {

                        }}>
                            <TableCell>
                                <NavLink className={'flex sm:flex-row items-center'} to={"/user/" + item.FromId}>
                                    <img
                                        className={'w-[40px] h-[40px] rounded-full mr-2'}
                                        src={`${AVATAR_API}${item.FromId}`}
                                    />
                                    <span className={'hover:scale-105 transition-transform hover:text-gray-500'}>{item.FromName}</span>
                                    {item.MedalLevel != 0 ?
                                        <Tooltip content={<HoverMedals mid={item.FromId} />}>
                                            <Chip
                                                className={'basis-64'}
                                                startContent={item.MedalLevel != 0 ? <img src={getGuardIcon(item.GuardLevel)} /> : <CheckIcon size={18} />}

                                                variant="faded"
                                                onClick={() => {

                                                }}
                                                style={{ background: getColor(item.MedalLevel), color: 'white', marginLeft: '8px' }}
                                            >
                                                {item.MedalName}
                                                <span className="ml-2 text-xs font-bold px-2 py-0.5 rounded-full">
                                                    {item.MedalLevel}
                                                </span>
                                            </Chip>
                                        </Tooltip>
                                        : <></>}
                                </NavLink>
                            </TableCell>
                            {/*<TableCell>{item.Liver}</TableCell>*/}
                            <TableCell>{item.CreatedAt}</TableCell>
                            <TableCell className={
                                (item.ActionName !== "msg" ? "font-bold" : "") +
                                (item.ID == highLight ? "bg-yellow-200" : "")
                            }>{item.Extra}{item.ActionName !== "msg" && <span>*{item.GiftAmount.Int16 || ''}  ￥{item.GiftPrice}</span>}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            {stream && stream !== '' && <Draggable nodeRef={ref}>
                <div ref={ref} className={'fixed bottom-3 right-3'} onContextMenu={e => {
                    e.preventDefault()
                    setMenu(!menu)
                }} onMouseLeave={() => {
                    setMenu(false)
                }}>
                    {menu && <Dropdown>
                        <DropdownMenu>
                            <DropdownItem onClick={e => {
                                setMenu(false)
                                setPlaying(!playing)
                            }}>Play/Stop</DropdownItem>
                            <DropdownItem onClick={() => {
                                setStream('')
                            }}>Close</DropdownItem>
                            <DropdownItem onClick={e => {
                                setMenu(false)
                                videoRef.current.requestFullscreen()
                            }}>Fullscreen</DropdownItem>
                        </DropdownMenu>

                    </Dropdown>}
                    {/*                    <ReactPlayer src={stream} playing={playing} onPlaying={() => {

                    }} ref={videoRef}/>*/}

                </div>
            </Draggable>}
        </div>
    );
}




export default LiveDetailPage;